import createUniNav from '@alchemer/universal-navigation/nav';
import { Grip } from 'lucide-react';
import { useEffect } from 'react';
import { useAppPermissions, useSdkToken } from '@/api/queries/useSdkTokenQuery';
import { useUniversalNavSync } from '@/hooks/useUniversalNavSync';
import { useProductUrls } from '@/hooks/useProductUrls';
import { useFlag } from '@alchemer/unleash';
import { FEATURE_FLAGS } from '@/config/features';

export default function UniNav() {
  const appPermissions = useAppPermissions();
  const sdkToken = useSdkToken();
  const productUrls = useProductUrls();

  const isForesterDemo = useFlag(FEATURE_FLAGS.FORESTER_DEMO);

  useUniversalNavSync();

  useEffect(() => {
    if (sdkToken && appPermissions) {
      const disabledProducts = Object.entries(appPermissions)
        .filter(([, hasAccess]) => !hasAccess)
        .map(([product]) => product);
      console.log('disabledProducts:', disabledProducts);

      createUniNav({
        anchorId: 'dashboardNavAnchor',
        productUrls,
        disabledProducts,
        featureFlags: {
          showSurvey: true,
          showDigital: true,
          showReputation: isForesterDemo,
          showWorkflow: true,
          showDashboards: true,
          showPulse: true,
          showListings: isForesterDemo,
        },
      });
    }
  }, [appPermissions, sdkToken, productUrls, isForesterDemo]);

  return (
    <div
      id="dashboardNavAnchor"
      className="uni-nav__trigger"
    >
      <Grip
        height={16}
        width={16}
        strokeWidth={2}
      />
    </div>
  );
}
